import React from 'react';
import PropTypes from 'prop-types';
import { ProductConfiguration } from '../../products/productConfiguration';

export class ProductGroupMarketingComponent extends React.PureComponent {
  static propTypes = {
    marketing: PropTypes.shape({
      supportsHardox: PropTypes.bool.isRequired,
      supportsStrenx: PropTypes.bool.isRequired,
    }).isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
  };

  render() {
    const { marketing, productConfiguration } = this.props;
    return (
      <div className="marketing-logo-container mt-1">
        {marketing.supportsHardox && (
          <img
            className="marketing-logo"
            alt="Hardox Logo"
            src={productConfiguration.productMarketing.hardoxLogoUrl}
          />
        )}
        {marketing.supportsStrenx && (
          <img
            className="marketing-logo"
            alt="Strenx Logo"
            src={productConfiguration.productMarketing.strenxLogoUrl}
          />
        )}
      </div>
    );
  }
}
